import { alpha } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/material/styles';
import { SEARCE_COLORS } from '../../../theme';

/** Default MUI Skeleton animation for the app */
export const SKELETON_ANIMATION: 'wave' | false = 'wave';

/**
 * Subtle fill so skeletons read as “loading” without harsh grey blocks.
 */
export const skeletonTintSx: SxProps<Theme> = {
  bgcolor: alpha(SEARCE_COLORS.primary, 0.08),
};
